import PropTypes from 'prop-types'
import React from 'react'
import { has, isEmpty } from 'lodash-es'
import { intl } from 'lang/intl'

import { useSiteQuery } from '../../../global/blocs/useSite'

import './WebinarRoomHeaderComponent.scss'

const getLogo = (src, site) => {
  if (
    has(site, 'presentation_webinarRoomLogo__link') &&
    !isEmpty(site.presentation_webinarRoomLogo__link)
  ) {
    return site.presentation_webinarRoomLogo__link
  }

  if (src) {
    return src
  }

  return '/files/sitelogo.png'
}

const WebinarRoomHeaderComponent = ({ src, children }) => {
  const { data: site } = useSiteQuery()

  return (
    <div className="webinar-room-header-component">
      <img
        className="site-logo"
        src={getLogo(src, site)}
        alt={intl.formatMessage({ defaultMessage: 'logo' })}
      />
      {children}
    </div>
  )
}

WebinarRoomHeaderComponent.propTypes = {
  src: PropTypes.string,
  children: PropTypes.node,
}

export default WebinarRoomHeaderComponent
